module.exports = [
  {
    "title": "Antioxidants with Vitamin C & Bioflavonoids",
    "description": "",
    "sku": "ACB-120-01",
    "product_id": 137,
    "name": "Antioxidants with Vitamin C & Bioflavonoids",
    "category_name": [
      "Daily Essentials"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Relief Factor Antioxidants with Vitamin C & Bioflavonoids you will automatically receive the regular 120-capsule supply shipped in 60 days and then every 2 months unless you cancel. Your card will be charged $25.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "d2c7d29a-484c-4791-871f-6300060fa02b",
    "offer_id": "7c5adf23-ef81-4dca-a1b3-b72e3d1f6f48",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/a/n/antioxidants-lg.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "25.95",
    "single_price": "30.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Berberine",
    "description": "",
    "sku": "BER-60-01",
    "product_id": 141,
    "name": "Berberine",
    "category_name": [
      "Daily Essentials"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Berberine you will automatically receive the regular 60-capsule supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $32.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "66aa5ec3-0e7c-45d7-83e8-3ac6b6e2bf98",
    "offer_id": "336edfe5-e3e3-44c4-9657-6225f19d856c",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/b/e/berberine-lg.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "32.95",
    "single_price": "38.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "COQ10",
    "description": "",
    "sku": "COQ10",
    "product_id": 96,
    "name": "CoQ10",
    "category_name": [
      "Default Category",
      "Supplements",
      "Free Shipping on these items"
    ],
    "bundleProduct": "",
    "disclaimer": "",
    "plan_id": "fbeb5e08-6fde-474e-9022-1be5eeccd218",
    "offer_id": "ea324a32-9068-41cd-b776-652cf2a06c7d",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/q/s/qs-front_1_45.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "0.00",
    "single_price": "14.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": false
  },
  {
    "title": "Calm",
    "description": "",
    "sku": "CLM-60-01",
    "product_id": 117,
    "name": "Relief Factor Calm 60 Count",
    "category_name": [
      "Calm"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Relief Factor Calm you will automatically receive the regular 60-capsule supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $21.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "b5e92d67-92c8-4d8d-9f35-be925b99633f",
    "offer_id": "6c546628-6435-4490-8675-4097e4f87f52",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/r/f/rfcalm.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "21.95",
    "single_price": "28.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Try It",
    "description": "As little as 99¢ per dose!",
    "sku": "ENR-60-01",
    "product_id": 118,
    "name": "1 Bottle",
    "category_name": [
      "Supplements",
      "Free Shipping on these items",
      "Email Template - Energy 1x60",
      "Energy"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Relief Factor Energy you will automatically receive the regular 60-capsules supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $29.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "61cb60a9-3f56-4cfd-8b11-69a2ff790441",
    "offer_id": "8f1b2495-7f54-4aef-bf07-a7afd18f5aaf",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/e/n/energy-pills-single_8.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "29.95",
    "single_price": "34.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": false
  },
  {
    "title": "Most Popular",
    "description": "As little as 83¢ per dose!",
    "sku": "ENR-60-01",
    "product_id": 118,
    "name": "3 Bottles",
    "category_name": [
      "Supplements",
      "Free Shipping on these items",
      "Email Template - Energy 1x60",
      "Energy"
    ],
    "bundleProduct": "3bottles",
    "disclaimer": "<p>When you purchase Relief Factor Energy you will automatically receive the regular 180-capsules supply shipped in 90 days and then monthly thereafter unless you cancel. Your card will be charged $24.85 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p> ",
    "plan_id": "61cb60a9-3f56-4cfd-8b11-69a2ff790441",
    "offer_id": "7b8763a1-9acc-45e1-ae20-5cb8be777e93",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/e/n/energy-pills-three_1.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "74.55",
    "single_price": "89.85",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": false
  },
  {
    "title": "Best Value",
    "description": "As little as 66¢ per dose!",
    "sku": "ENR-60-01",
    "product_id": 118,
    "name": "6 Bottles",
    "category_name": [
      "Supplements",
      "Free Shipping on these items",
      "Email Template - Energy 1x60",
      "Energy"
    ],
    "bundleProduct": "6bottles",
    "disclaimer": "<p>When you purchase Relief Factor Energy you will automatically receive the regular 360-capsules supply shipped in 180 days and then monthly thereafter unless you cancel. Your card will be charged $19.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "61cb60a9-3f56-4cfd-8b11-69a2ff790441",
    "offer_id": "9db1923d-5d38-424a-a93c-25a3fbaac4c5",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/e/n/energy-pills-six_3.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "119.70",
    "single_price": "149.70",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": false
  },
  {
    "title": "Full Spectrum E",
    "description": "",
    "sku": "FSE-120-01",
    "product_id": 138,
    "name": "Full Spectrum E",
    "category_name": [
      "Daily Essentials"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Full Spectrum E you will automatically receive the regular 120-capsule supply shipped in 60 days and then every 2 months unless you cancel. Your card will be charged $42.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "6d9c9293-1d80-4858-a897-bf9659f9b715",
    "offer_id": "20ea0e29-2d4f-47f5-82dd-dd27735a4817",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/f/u/full-spectrum-e-lg.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "42.95",
    "single_price": "50.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Go Factor 60CT - 1 Bottle",
    "description": "As little as 99¢ per dose!",
    "sku": "GOF-60-01",
    "product_id": 126,
    "name": "Go Factor (60 count)",
    "category_name": [
      "Supplements",
      "Free Shipping on these items",
      "Email Template - Energy 1x60",
      "Energy",
      "Feel the difference"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Go Factor you will automatically receive the regular 60-capsules supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $29.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "61cb60a9-3f56-4cfd-8b11-69a2ff790441",
    "offer_id": "d5bca645-9f91-4d04-903f-d889656fb7bc",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/g/o/go-factor_1.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "29.95",
    "single_price": "34.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Go Factor 60CT - 3 Bottles",
    "description": "As little as 83¢ per dose!",
    "sku": "GOF-60-01",
    "product_id": 126,
    "name": "Go Factor (60 count)",
    "category_name": [
      "Supplements",
      "Free Shipping on these items",
      "Email Template - Energy 1x60",
      "Energy",
      "Feel the difference"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Go Factor you will automatically receive the regular 180-capsules supply shipped in 90 days and then monthly thereafter unless you cancel. Your card will be charged $24.85 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p> ",
    "plan_id": "61cb60a9-3f56-4cfd-8b11-69a2ff790441",
    "offer_id": "5a1148b9-4c83-4609-9144-2e400b6789a3",
    "qty": 3,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/g/o/go-factor_1.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "29.95",
    "single_price": "34.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Go Factor 60CT - 6 Bottles",
    "description": "As little as 66¢ per dose!",
    "sku": "GOF-60-01",
    "product_id": 126,
    "name": "Go Factor (60 count)",
    "category_name": [
      "Supplements",
      "Free Shipping on these items",
      "Email Template - Energy 1x60",
      "Energy",
      "Feel the difference"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Go Factor you will automatically receive the regular 360-capsules supply shipped in 180 days and then monthly thereafter unless you cancel. Your card will be charged $19.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "61cb60a9-3f56-4cfd-8b11-69a2ff790441",
    "offer_id": "b1f14f8a-21e8-4217-ba1f-601c3ad1f6a0",
    "qty": 6,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/g/o/go-factor_1.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "29.95",
    "single_price": "34.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Immune Factors",
    "description": "",
    "sku": "IMF-120-01",
    "product_id": 139,
    "name": "IMMUNE FACTORS",
    "category_name": [
      "Daily Essentials"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Immune Factors you will automatically receive the regular 120-capsule supply shipped in 60 days and then every 2 months unless you cancel. Your card will be charged $89.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "d47d3651-38b6-4cfe-8f86-a99dab3f3f46",
    "offer_id": "de9b7418-a8ca-4f99-968b-98f4f741d11d",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/i/m/immune-factors-lg.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "89.95",
    "single_price": "105.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "NAC N-Acetyl L-Cysteine",
    "description": "",
    "sku": "NAC-120-01",
    "product_id": 140,
    "name": "NAC (N-Acetyl L-Cysteine)",
    "category_name": [
      "Daily Essentials"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase NAC N-Acetyl L-Cysteine you will automatically receive the regular 120-capsule supply shipped in 60 days and then every 2 months unless you cancel. Your card will be charged $21.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "269efb0d-f1d6-405f-8899-7644b2e2dd97",
    "offer_id": "e239c2da-8ab1-4b1b-b104-52b3f1d165ad",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/n/a/nac-lg.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "21.95",
    "single_price": "25.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Red Yeast Rice with CoQ10",
    "description": "",
    "sku": "RYR-120-01",
    "product_id": 143,
    "name": "Red Yeast Rice with CoQ10",
    "category_name": [
      "Daily Essentials"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Red Yeast Rice with CoQ10 you will automatically receive the regular 120-capsule supply shipped in 60 days and then every 2 months unless you cancel. Your card will be charged $46.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "f9f19f38-8780-45ae-b0a9-28654370744d",
    "offer_id": "be436484-7c45-4812-8c36-a626fb7c2565",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/r/e/red-yeast-rice-lg.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "46.95",
    "single_price": "54.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Relief Factor - 60 Pack",
    "description": "<ul><li><span class=bc></span>Convenient monthly shipments</li><li><span class=bc></span>Free gift each month</li><li><span class=bc></span>Relax knowing you won’t run out</li></ul>",
    "sku": "REL-60-01",
    "product_id": 116,
    "name": "60-ct Bag",
    "category_name": [
      "Supplements",
      "Relief Factor",
      "Feel the difference"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>For your convenience, when you purchase Relief Factor Initial 60 Pack at the Subscribe & Save price, your next order will be shipped in one month and then every month thereafter until you cancel. Your card will be charged $79.95 + $6.95 S&H each time your next supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "98eb55e1-658b-4f2e-a71e-844b093699b1",
    "offer_id": "f693de48-4b3f-4a20-9c65-19f5111e9734",
    "qty": 1,
    "free_products": [
      {
        "sku": "FREE_VITD",
        "name": "Vitamin D3",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-d_1.jpg",
        "productId": "75"
      },
      {
        "sku": "FREE_VITC",
        "name": "Vitamin C",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-c.png",
        "productId": "98"
      }
    ],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/r/f/rf60-wfree_1_1.png",
    "trigger_type": 1,
    "initial_price": "0.00",
    "recurring_price": "79.95",
    "single_price": "93.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": false
  },
  {
    "title": "Relief Factor 60CT",
    "description": "<ul><li><span class=bc></span>Convenient monthly shipments</li><li><span class=bc></span>Free gift each month</li><li><span class=bc></span>Relax knowing you won’t run out</li></ul>",
    "sku": "REL-60-02",
    "product_id": 121,
    "name": "60-ct Bag",
    "category_name": [
      "Supplements",
      "Relief Factor",
      "Non California Products",
      "Feel the difference"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>For your convenience, when you purchase Relief Factor Initial 60 CT at the Subscribe & Save price, your next order will be shipped in one month and then every month thereafter until you cancel. Your card will be charged $79.95 + $6.95 S&H each time your next supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "98eb55e1-658b-4f2e-a71e-844b093699b1",
    "offer_id": "69d332a4-29b1-41db-b8a7-45ab30796cb6",
    "qty": 1,
    "free_products": [
      {
        "sku": "FREE_VITD",
        "name": "Vitamin D3",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-d_1.jpg",
        "productId": "75"
      },
      {
        "sku": "FREE_VITC",
        "name": "Vitamin C",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-c.png",
        "productId": "98"
      }
    ],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/r/e/relief-factor-img_1.png",
    "trigger_type": 1,
    "initial_price": "0.00",
    "recurring_price": "79.95",
    "single_price": "93.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Relief Factor 60CT NEC",
    "description": "<ul><li><span class=bc></span>Convenient monthly shipments</li><li><span class=bc></span>Free gift each month</li><li><span class=bc></span>Relax knowing you won’t run out</li></ul>",
    "sku": "REL-60-04",
    "product_id": 134,
    "name": "60-ct Bag",
    "category_name": [
      "Supplements",
      "Relief Factor",
      "Non California Products",
      "Feel the difference"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>For your convenience, when you purchase Relief Factor Initial 60 CT at the Subscribe & Save price, your next order will be shipped in one month and then every month thereafter until you cancel. Your card will be charged $84.95 + $6.95 S&H each time your next supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "98eb55e1-658b-4f2e-a71e-844b093699b1",
    "offer_id": "e93a7a6f-82d2-4a4e-8d9d-1bfa02129f36",
    "qty": 1,
    "free_products": [
      {
        "sku": "FREE_VITD",
        "name": "Vitamin D3",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-d_1.jpg",
        "productId": "75"
      },
      {
        "sku": "FREE_VITC",
        "name": "Vitamin C",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-c.png",
        "productId": "98"
      }
    ],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/r/f/rf-pain-relief_3.png",
    "trigger_type": 1,
    "initial_price": "19.95",
    "recurring_price": "84.95",
    "single_price": "98.95",
    "naswithrfqs_price": "34.95",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Relief Factor QuickStart",
    "description": "<ul><li><span class=bc></span>Convenient three-week trial</li><li><span class=bc></span>49 packets of Relief Factor</li><li><span class=bc></span>147-page Anti-Inflammation Diet</li></ul><h4 class='inside-head'>Plus Ongoing Subscribe  &amp; Save </h4><ul><li><span class=bc></span>Relief Factor 60-count bag ($79.95)</li><li><span class=bc></span>Free gift each month</li><li><span class=bc></span>Relax knowing you won’t run out</li></ul>",
    "sku": "REL-60-02",
    "product_id": 121,
    "name": "60-ct Bag",
    "category_name": [
      "Supplements",
      "Relief Factor",
      "Non California Products",
      "Feel the difference"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>For your convenience, your purchase of Relief Factor is followed by a full month's supply (60 packets) of Relief Factor shipped in 3 weeks and then every month thereafter unless you cancel. Your card will be charged $79.95 + $6.95 S&H each time your next supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "98eb55e1-658b-4f2e-a71e-844b093699b1",
    "offer_id": "0a9a4a04-20bb-4654-afd4-843dc4ebcade",
    "qty": 1,
    "free_products": [
      {
        "sku": "FREE_VITD",
        "name": "Vitamin D3",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-d_1.jpg",
        "productId": "75"
      },
      {
        "sku": "FREE_VITC",
        "name": "Vitamin C",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-c.png",
        "productId": "98"
      }
    ],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/r/e/relief-factor-img_1.png",
    "trigger_type": 1,
    "initial_price": "19.95",
    "recurring_price": "79.95",
    "single_price": "93.95",
    "naswithrfqs_price": "34.95",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Relief Factor QuickStart NEC",
    "description": "<ul><li><span class=bc></span>Convenient three-week trial</li><li><span class=bc></span>49 packets of Relief Factor</li><li><span class=bc></span>147-page Anti-Inflammation Diet</li></ul><h4 class='inside-head'>Plus Ongoing Subscribe  &amp; Save </h4><ul><li><span class=bc></span>Relief Factor 60-count bag ($84.95)</li><li><span class=bc></span>Free gift each month</li><li><span class=bc></span>Relax knowing you won’t run out</li></ul>",
    "sku": "REL-60-04",
    "product_id": 134,
    "name": "60-ct Bag",
    "category_name": [
      "Supplements",
      "Relief Factor",
      "Non California Products",
      "Feel the difference"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>For your convenience, your purchase of Relief Factor is followed by a full month's supply (60 packets) of Relief Factor shipped in 3 weeks and then every month thereafter unless you cancel. Your card will be charged $84.95 + $6.95 S&H each time your next supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "98eb55e1-658b-4f2e-a71e-844b093699b1",
    "offer_id": "a7b3fcb1-92e4-4b6f-a05e-e8d7f072ca8d",
    "qty": 1,
    "free_products": [
      {
        "sku": "FREE_VITD",
        "name": "Vitamin D3",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-d_1.jpg",
        "productId": "75"
      },
      {
        "sku": "FREE_VITC",
        "name": "Vitamin C",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-c.png",
        "productId": "98"
      }
    ],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/r/f/rf-pain-relief_3.png",
    "trigger_type": 1,
    "initial_price": "19.95",
    "recurring_price": "84.95",
    "single_price": "98.95",
    "naswithrfqs_price": "34.95",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Relief Factor QuickStart – 49 Pack",
    "description": "<ul><li><span class=bc></span>Convenient three-week trial</li><li><span class=bc></span>49 packets of Relief Factor</li><li><span class=bc></span>147-page Anti-Inflammation Diet</li></ul><h4 class='inside-head'>Plus Ongoing Subscribe  &amp; Save </h4><ul><li><span class=bc></span>Relief Factor 60-count bag ($79.95)</li><li><span class=bc></span>Free gift each month</li><li><span class=bc></span>Relax knowing you won’t run out</li></ul>",
    "sku": "REL-49-01",
    "product_id": 115,
    "name": " 3-Week QuickStart",
    "category_name": [
      "Supplements",
      "RF_QS Email Template",
      "RFQS",
      "Relief Factor"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>For your convenience, your purchase of QuickStart is followed by a full month's supply (60 packets) of Relief Factor shipped in 3 weeks and then every month thereafter unless you cancel. Your card will be charged $79.95 + $6.95 S&H each time your next supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "98eb55e1-658b-4f2e-a71e-844b093699b1",
    "offer_id": "d8210b55-0465-46ea-a843-831c03a57ab2",
    "qty": 1,
    "free_products": [
      {
        "sku": "FREE_VITD",
        "name": "Vitamin D3",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-d_1.jpg",
        "productId": "75"
      },
      {
        "sku": "FREE_VITC",
        "name": "Vitamin C",
        "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-c.png",
        "productId": "98"
      }
    ],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/r/f/rfqs-wfreeguide_1__1_.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "19.95",
    "single_price": "33.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": false
  },
  {
    "title": "Sleep",
    "description": "",
    "sku": "SLP-60-01",
    "product_id": 119,
    "name": "Relief Factor Sleep 60 Count",
    "category_name": [
      "Rf-Sleep"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Relief Factor Sleep you will automatically receive the regular 60-capsule supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $29.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "11d07b11-0cd4-45be-b42e-4285f2d5b4a7",
    "offer_id": "f95176e3-5730-4ae2-83ce-c4e5a1038b1f",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/r/f/rf-sleep-500_1.png",
    "trigger_type": "",
    "initial_price": "19.95",
    "recurring_price": "29.95",
    "single_price": "36.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": false
  },
  {
    "title": "Think Factor",
    "description": "",
    "sku": "TNK-60-01",
    "product_id": 136,
    "name": "Think Factor",
    "category_name": [
      "Feel the difference",
      "Solution"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Think Factor you will automatically receive the regular 60-capsule supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $37.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "3e7f9c2d-8b45-4a1e-bd72-f06a3c9e5d8a",
    "offer_id": "f9d3a7b2-5c8e-41fd-9e3a-7a4c2d6b8f01",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/t/h/think-factor_1.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "37.95",
    "single_price": "44.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Vessel Protection",
    "description": "",
    "sku": "VEP-60-01",
    "product_id": 144,
    "name": "Vessel Protection",
    "category_name": [
      "Daily Essentials"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Vessel Protection you will automatically receive the regular 60-capsule supply shipped in 60 days and then every 2 months unless you cancel. Your card will be charged $22.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "fe69b935-5c3e-46a4-8cb2-b5aae68ce108",
    "offer_id": "4a2a06a9-0b5c-4b34-a401-3fd98ba46b0e",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/e/vessel-protection-lg.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "22.95",
    "single_price": "26.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Vitamin B Complex",
    "description": "",
    "sku": "VBC-120-01",
    "product_id": 142,
    "name": "Vitamin B Complex",
    "category_name": [
      "Daily Essentials"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Vitamin B Complex you will automatically receive the regular 120-capsule supply shipped in 60 days and then every 2 months unless you cancel. Your card will be charged $22.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "6573caad-3d05-474a-8573-96753d1fc599",
    "offer_id": "fdfca5b5-6b9c-46ef-b341-4292b0626c38",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-b-complex-lg.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "22.95",
    "single_price": "26.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Vitamin D3 and K-2 2000iu",
    "description": "",
    "sku": "DK2-120-01",
    "product_id": 145,
    "name": "Vitamin D3 and K-2 2000iu",
    "category_name": [
      "Daily Essentials"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Vitamin D3 and K-2 2000iu you will automatically receive the regular 120-capsule supply shipped in 60 days and then every 2 months unless you cancel. Your card will be charged $12.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "267702c9-cba8-46bb-b04e-7da1261cd41f",
    "offer_id": "4e44b8c0-579d-4ff7-a581-e4051a6b7962",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-d3k2-2000-lg.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "12.95",
    "single_price": "15.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Vitamin D3 and K-2 5000iu",
    "description": "",
    "sku": "DK5-120-01",
    "product_id": 146,
    "name": "Vitamin D3 and K-2 5000iu",
    "category_name": [
      "Daily Essentials"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Vitamin D3 and K-2 5000iu you will automatically receive the regular 120-capsule supply shipped in 60 days and then every 2 months unless you cancel. Your card will be charged $23.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "278c806c-4f6b-4449-a305-f4c6498d2eda",
    "offer_id": "d312ccbb-ca76-470d-b131-0955d8bb92d7",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/v/i/vitamin-d3k2-5000-lg.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "23.95",
    "single_price": "28.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  },
  {
    "title": "Z Factor 60CT",
    "description": "",
    "sku": "ZFA-60-01",
    "product_id": 125,
    "name": "Z Factor (60 count)",
    "category_name": [
      "Rf-Sleep",
      "Feel the difference"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Relief Factor Z Factor you will automatically receive the regular 60-capsule supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $29.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "11d07b11-0cd4-45be-b42e-4285f2d5b4a7",
    "offer_id": "b80bb1fc-1fef-42a3-8432-90b1b429777a",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/z/-/z-factor_1.png",
    "trigger_type": "",
    "initial_price": "19.95",
    "recurring_price": "29.95",
    "single_price": "36.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": false
  },
  {
    "title": "Zen Factor 60CT",
    "description": "",
    "sku": "ZEN-60-01",
    "product_id": 123,
    "name": "Zen Factor (60 count)",
    "category_name": [
      "Calm",
      "Feel the difference"
    ],
    "bundleProduct": "",
    "disclaimer": "<p>When you purchase Zen Factor you will automatically receive the regular 60-capsule supply shipped in 30 days and then monthly thereafter unless you cancel. Your card will be charged $21.95 + applicable state taxes each time your supply ships. To cancel, call 833-888-1533 or send an email to contactus@relieffactor.com at least 1 day before your next supply ships.</p>",
    "plan_id": "b5e92d67-92c8-4d8d-9f35-be925b99633f",
    "offer_id": "4a35194f-d1cb-4e59-a956-b1135961184f",
    "qty": 1,
    "free_products": [],
    "image_url": "http://restapi.relieffactor.com/media/catalog/product/z/e/zen-factor_3.png",
    "trigger_type": "",
    "initial_price": "0.00",
    "recurring_price": "21.95",
    "single_price": "28.95",
    "naswithrfqs_price": "0.00",
    "isEligibleForSingleOrder": true
  }
];